const config = {
  backgroundColor: "rgba(0, 0, 0, 0.3)",
  modalBackgroundColor: "#fff",
  fadeInTime: "0.5s",
  loadingImageUrl:
    "//dev-finkid.myshopify.com/cdn/shop/t/7/assets/finkid-logo-white.svg",
};

!(function (e, t, n, c, r, a, i) {
  (e.Newsletter2GoTrackingObject = r),
    (e[r] =
      e[r] ||
      function () {
        (e[r].q = e[r].q || []).push(arguments);
      }),
    (e[r].l = 1 * new Date()),
    (a = t.createElement(n)),
    (i = t.getElementsByTagName(n)[0]),
    (a.async = 1),
    (a.src = c),
    i.parentNode.insertBefore(a, i);
})(
  window,
  document,
  "script",
  "https://static.newsletter2go.com/utils.js",
  "n2g"
);

const n2gConfig = {
  form: {
    class: "newsletter-form",
    style: "display: flex; width: 100%; margin: 0; max-width: unset;",
  },
  container: {
    type: "div",
    class: "",
    style: "display: flex; flex-direction: column; gap: 8px; width: 100%;",
  },
  row: {
    type: "div",
    class: "p",
    style: "text-align: center;",
  },
  columnLeft: {
    type: "div",
    class: "",
    style: "display: none;",
  },
  columnRight: {
    type: "div",
    class: "",
    style: "",
  },
  checkbox: {
    type: "input",
    class: "p",
    style: "",
  },
  separator: {
    type: "br",
    class: "",
    style: "",
  },
  input: {
    class: "p",
    style: "padding: 12px 10px; border-radius: 4px; width: 100%; border: 1px solid #434748;",
  },
  dropdown: {
    type: "select",
    class: "",
    style: "padding: 3px 5px; border-radius: 2px; border: 1px solid #d8dee4;",
  },
  button: {
    type: "button",
    class: "p",
    id: "",
    style:
      "background-color: #104FB5; border: none; border-radius: 4px; padding: 10px 20px; color: #fff; width: 100%; cursor: pointer;",
  },
  label: {
    type: "label",
    class: "p",
    style: "width: 100%; align-self: center;",
  },
  loader: {
    type: "img",
    src: "//www.newsletter2go.com/images/loader.svg",
    class: "",
    style: "margin: auto; display:block; width: auto;",
  },
  message: {
    type: "h2",
    class: "p",
    id: "",
    style: "text-align: center;",
  },
  captchaImage: {
    type: "img",
    class: "",
    style:
      "padding: 5px; border: 0px solid #fff; margin-top: 5px; width: 32px; height: 32px; cursor: pointer; display:inline;",
    "style:active":
      "padding: 5px; border: 3px solid #ccc; margin-top: 5px; width: 32px; height: 32px; cursor: pointer;",
  },
};

function createModal() {
  const modal = document.createElement("div");
  modal.id = "newsletter-modal";
  modal.style.cssText = `
      position: fixed;
      z-index: 1000;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: ${config.backgroundColor};
      transition: opacity ${config.fadeInTime} ease;
      opacity: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    `;

  const modalContent = document.createElement("div");
  modalContent.id = "newsletter-modalContent";
  modalContent.style.cssText = `
      background-color: ${config.modalBackgroundColor};
      padding: 20px;
      border-radius: 5px;
      max-width: 500px;
      width: 90%;
      opacity: 0;
      transition: opacity 0.3s ease;
    `;

  const loadingImg = document.createElement("img");
  loadingImg.src = config.loadingImageUrl;
  loadingImg.id = "newsletter-loading";
  loadingImg.style.cssText = `
      position: absolute;
      top: 50%;
      left: 50%;
      width: 200px;
      height: auto;
      transform: translate(-50%, -50%);
    `;

  const modalTitle = document.createElement("h3");
  modalTitle.textContent = "Newsletter Anmeldung";
  modalTitle.style.cssText = `
      margin-top: 0;
      margin-bottom: 10px;
      text-transform: uppercase;
    `;

  const closeBtn = document.createElement("span");
  closeBtn.innerHTML = "&#x2715;";
  closeBtn.style.cssText = `
      color: #434748;
      float: right;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
    `;

  modalContent.appendChild(closeBtn);
  modalContent.appendChild(modalTitle);

  const formContainer = document.createElement("div");
  formContainer.id = "n2g-formular";
  modalContent.appendChild(formContainer);

  modal.appendChild(loadingImg);
  modal.appendChild(modalContent);

  // n2g Aufruf
  setTimeout(() => {
    n2g("create", "yi87xucn-kf48otav-1534");
    n2g("subscribe:createForm", n2gConfig, "n2g-formular");
  }, 50);

  return modal;
}

function openModal() {
  const modal = createModal();
  const modalContent = modal.querySelector("#newsletter-modalContent");
  const loadingImg = modal.querySelector("#newsletter-loading");
  const closeBtn = modal.querySelector("span");

  closeBtn.onclick = () => closeModal(modal);
  modal.onclick = (event) => {
    if (event.target === modal) closeModal(modal);
  };

  document.body.appendChild(modal);

  const checkFormRendered = () => {
    if (document.querySelector(".newsletter-form")) {
      loadingImg.style.display = "none";
      modalContent.style.opacity = "1"; // fade in form
    } else {
      setTimeout(checkFormRendered, 500);
    }
  };

  setTimeout(() => {
    modal.style.opacity = "1";
  }, 10);

  checkFormRendered();
}

function closeModal(modal) {
  modal.style.opacity = "0";
  setTimeout(() => {
    document.body.removeChild(modal);
  }, 300);
}

const registrationElements =
  document.getElementsByClassName("finkid-newsletter");
Array.from(registrationElements).forEach((element) => {
  element.addEventListener("click", openModal);
});
